import { attempt } from "lodash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	selectedTest: null,
	examId: null,
	testType: null,
	topicDistribution: null,
	attempt: null,
	reattemptId: null,
};

const testSelectionSlice = createSlice({
	name: "testSelection",
	initialState,
	reducers: {
		selectTest: (state, action) => {
			state.selectedTest = action.payload;
		},
		setExamId: (state, action) => {
			state.examId = action.payload; // Stores test ID separately
		},
		createTest: (state, action) => {
			state.testType = action.payload?.testType;
			state.topicDistribution = action.payload?.topicDistribution;
		},
		clearSelection: (state) => {
			state.selectedTest = null;
		},
		setAttempt: (state, action) => {
			state.attempt = action.payload;
		},
		setReattemptId: (state, action) => {
			state.reattemptId = action.payload;
		},
		resetTest: (state, action) => {
			state.examId = null;
			state.testType = null;
			state.topicDistribution = null;
			state.attempt = null;
		},
	},
});

export const {
	selectTest,
	setExamId,
	createTest,
	clearSelection,
	setAttempt,
	setReattemptId,
	resetTest,
} = testSelectionSlice.actions;

export default testSelectionSlice.reducer;
